import { useCallback, useState } from 'react';
import { getPermissionResourceKeyFromPath } from '@/lib/permissions';
import { toast as hotToast } from '@/lib/hot-toast';
import { useAuth } from '@/contexts/auth-context';

export const useGiaMuaImport = () => {
  const { permissions, isAdmin } = useAuth();
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const [isLoadingImport, setIsLoadingImport] = useState(false);

  const getPermission = (action: 'create' | 'update' | 'delete') => {
    if (isAdmin) return true;
    const resourceKey = getPermissionResourceKeyFromPath(window.location.pathname);
    return resourceKey ? permissions[resourceKey]?.[action] === true : false;
  };

  const openImportDialog = useCallback(() => {
    if (!getPermission('create')) {
      hotToast.error('Bạn chưa được phân quyền để thực hiện tính năng này');
      return;
    }
    setIsImportDialogOpen(true);
  }, [permissions, isAdmin]);

  const closeImportDialog = useCallback(() => {
    setIsImportDialogOpen(false);
  }, []);

  const toggleImportDialog = useCallback(() => {
    if (!getPermission('create')) {
      hotToast.error('Bạn chưa được phân quyền để thực hiện tính năng này');
      return;
    }
    setIsImportDialogOpen(prev => !prev);
  }, [permissions, isAdmin]);

  return {
    isImportDialogOpen,
    isLoadingImport,
    openImportDialog,
    closeImportDialog,
    toggleImportDialog,
    setIsImportDialogOpen,
    setIsLoadingImport
  };
};
